<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_MsgClassifyManager')" name="msgClassifyManager">
              <msg-classify-manager-view />
            </el-tab-pane>
            <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BellMsg')" name="bellMsg">
              <bell-msg-view />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import msgClassifyManagerView from '@/views/cargo/v0/SystemMaintenance/components/sysMsgConfig/MsgClassifyManagerView'
import bellMsgView from '@/views/cargo/v0/SystemMaintenance/components/sysMsgConfig/BellMsgView'

export default {
  name: 'SysMsgConfig',
  components: { msgClassifyManagerView, bellMsgView },
  data() {
    return {
      activeTabName: 'msgClassifyManager'
    }
  },
  methods: {
    handleClick() {

    }
  }
}
</script>

<style scoped>

</style>
